import React from "react";
import { useTranslation } from "react-i18next";
import InternalLink from "../components/InternalLink";

const SkillCard = ({ skill }) => {
    const { t } = useTranslation();

    return (
        <div className="p-4 border border-gray-200 rounded-xl bg-white hover:shadow-md hover:border-gray-300 transition-all group">
            <div className="flex items-start gap-3">
                <span className="text-2xl flex-shrink-0 mt-0.5">{skill.icon}</span>
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                        <h3 className="font-semibold text-gray-900 truncate">{skill.name}</h3>
                        {skill.isNew && (
                            <span className="px-2 py-0.5 text-xs font-semibold bg-green-100 text-green-700 rounded-full">
                                {t("skillsPage.new")}
                            </span>
                        )}
                        {skill.isTrigger && (
                            <span className="px-2 py-0.5 text-xs font-semibold bg-purple-100 text-purple-700 rounded-full">
                                {t("skillsPage.trigger")}
                            </span>
                        )}
                        {skill.isCodeGenSkill && (
                            <span className="px-2 py-0.5 text-xs font-semibold bg-blue-100 text-blue-700 rounded-full">
                                {t("skillsPage.codeGen")}
                            </span>
                        )}
                    </div>
                    <p className="text-sm text-gray-500 line-clamp-2">
                        {t(skill.descriptionKey)}
                    </p>
                    <div className="flex items-center gap-3 mt-2">
                        {skill.isTrigger ? (
                            <span className="text-xs text-purple-600 font-medium">
                                {t("skillsPage.useInTrigger")}
                            </span>
                        ) : skill.isCodeGenSkill ? (
                            <span className="text-xs text-blue-600 font-medium">
                                @skills/{skill.id}
                            </span>
                        ) : (
                            <span className="text-xs text-blue-600 font-medium">
                                @[{skill.name}]
                            </span>
                        )}
                        {skill.docsLink && (
                            <InternalLink
                                to={skill.docsLink}
                                className="text-xs font-medium text-blue-600 hover:text-blue-800 underline"
                            >
                                {t("skillsPage.viewDocs")}
                            </InternalLink>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkillCard;
